import { ArpMediaType } from '@arpeggi/shared'
import { FC } from 'react'
import ProfileCard from '../../../__legacy__/components/platform/dashboard/ProfileCard'
import { IArpMedia } from '../../arp-registry/ArpMedia'
import { useCSSGradient } from '../hooks'
import { Main, TopNav } from '../primitives'
import { ArpContributorsSection } from './ArpContributorsSection'
import { ArpCoverArt } from './ArpCoverArt'
import { ArpPlayer } from './ArpPlayer'
import { ArpRecentActivity } from './ArpRecentActivity'
import { ArpTokenInfo } from './ArpTokenInfo'

export const ArpMainSection: FC<{ media: IArpMedia }> = ({ media }) => {
  const { gradient } = useCSSGradient(media)
  const hasCoverArt = media.mintExtras?.coverImage
  const isSample = media.type === ArpMediaType.SAMPLE
  return (
    <Main.Root css={{ background: gradient }}>
      <Main.Flare />
      <TopNav.Root>
        <TopNav.BackButton />
        <ProfileCard />
      </TopNav.Root>
      <Main.Content>
        <Main.PlayerArea>
          {hasCoverArt ? (
            <ArpCoverArt coverImageUrl={media.mintExtras?.coverImage?.url} />
          ) : (
            <ArpPlayer media={media} />
          )}
        </Main.PlayerArea>
        <Main.InfoArea>
          <ArpTokenInfo media={media} />
          {!isSample && <ArpContributorsSection media={media} />}
          <ArpRecentActivity media={media} />
        </Main.InfoArea>
      </Main.Content>
    </Main.Root>
  )
}
